module.exports = __webpack_public_path__ + "static/media/Well Seasoned _ Trek Bikes.bc8cb268.mp4";